import Schema from 'AppReact/schema';

export default {
  filtersCount: Schema('integer', 'primitive-nullable', { defaultValue: null }),
  containerRef: Schema({}, 'object', { defaultValue: null }),
  inputRef: Schema({}, 'object', { defaultValue: null }),
  suggestions: Schema('string', 'array', { defaultValue: [] }),
  searchTerm: Schema('string', 'primitive', { defaultValue: '' }),
  placeholder: Schema('string', 'primitive-nullable', { defaultValue: '' }),
  inputVal: Schema('string', 'primitive', { defaultValue: '' }),
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  isToggled: Schema('boolean', 'primitive', { defaultValue: false }),
  recentSearches: Schema('string', 'array', { defaultValue: [] }),
  showDropdown: Schema('boolean', 'primitive', { defaultValue: false }),
  isLoadingSuggestions: Schema('boolean', 'primitive', { defaultValue: false }),
}